var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Beauticians Directory',"subtitle":'Add new beautician'}}),_c('beautician-form',{attrs:{"action":'add'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }